export enum ORDER_SOURCE_TYPE {
  site = 'Сайт 24farmacia.ru',
  mobileSite = 'Мобильная версия',
}
